import React from 'react';
import Filter from '@uber/base-icons/filter';
import type { Theme } from 'baseui';
import { useStyletron } from 'baseui';
import { Button, KIND as BUTTON_KIND, SHAPE as BUTTON_SHAPE } from 'baseui/button';
import { Checkbox, LABEL_PLACEMENT, STYLE_TYPE } from 'baseui/checkbox';
import { StatefulMenu, StyledListItem } from 'baseui/menu';
import { PLACEMENT, StatefulPopover } from 'baseui/popover';
import { LabelXSmall } from 'baseui/typography';
import { useAtom } from 'jotai';
import type { AnnotationFilterEndEnhancerArgs } from '../../../../modernization-common/side-panel-m4';
import { videoFilterAtom } from '../../atoms/side-panel-atoms';
import { VIDEO_FILTERS } from '../../constants';
const BUTTON_OVERRIDES = {
  BaseButton: {
    style: {
      height: 'auto',
      width: 'auto'
    }
  }
};
const TOGGLE_OVERRIDES = {
  Label: {
    style: ({
      $theme
    }: {
      $theme: Theme;
    }) => ({
      ...$theme.typography.LabelSmall,
      fontWeight: 'normal'
    })
  },
  Root: {
    style: ({
      $theme
    }: {
      $theme: Theme;
    }) => ({
      display: 'flex',
      alignItems: 'center',
      padding: `${$theme.sizing.scale400}`,
      ':hover': {
        backgroundColor: $theme.colors.backgroundSecondary
      }
    })
  },
  ToggleTrack: {
    style: ({
      $theme
    }: {
      $theme: Theme;
    }) => ({
      width: $theme.sizing.scale800,
      height: $theme.sizing.scale550,
      margin: 0
    })
  },
  Toggle: {
    style: ({
      $theme
    }: {
      $theme: Theme;
    }) => ({
      width: $theme.sizing.scale400,
      height: $theme.sizing.scale400
    })
  }
};
const FILTER_MENU_ITEMS = [{
  label: 'Current Frame',
  id: VIDEO_FILTERS.CURRENT_FRAME
}];
export const FilterMenu = ({
  iconStyles
}: AnnotationFilterEndEnhancerArgs) => {
  const [videoFilter, setVideoFilter] = useAtom(videoFilterAtom);
  const [css, theme] = useStyletron();
  return <div className={css({
    display: 'flex',
    alignItems: 'center',
    gap: theme.sizing.scale600
  })}>
      <StatefulPopover content={() => <StatefulMenu items={FILTER_MENU_ITEMS} overrides={{
      Option: {
        component: ({
          item
        }) => {
          if (item.id === VIDEO_FILTERS.CURRENT_FRAME) {
            return <Checkbox checked={videoFilter === VIDEO_FILTERS.CURRENT_FRAME} onChange={e => setVideoFilter(e.target.checked ? VIDEO_FILTERS.CURRENT_FRAME : VIDEO_FILTERS.ALL)} labelPlacement={LABEL_PLACEMENT.left} checkmarkType={STYLE_TYPE.toggle} overrides={TOGGLE_OVERRIDES}>
                        <LabelXSmall>Current Frame</LabelXSmall>
                      </Checkbox>;
          }
          return <StyledListItem>{item.label}</StyledListItem>;
        }
      },
      List: {
        style: {
          width: 'max-content',
          padding: 0
        }
      }
    }} />} placement={PLACEMENT.bottom}>
        <Button kind={BUTTON_KIND.tertiary} shape={BUTTON_SHAPE.circle} overrides={BUTTON_OVERRIDES}>
          <Filter {...iconStyles} />
        </Button>
      </StatefulPopover>
    </div>;
};